export const getCardStatus = (state) => state.status
export const getCards = (state) => state.cards
export const getAssignedCards = (state) => state.assignedCard